/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleBookingDisplay } from './VehicleBookingDisplay';
import {
    VehicleBookingDisplayFromJSON,
    VehicleBookingDisplayFromJSONTyped,
    VehicleBookingDisplayToJSON,
    VehicleBookingDisplayToJSONTyped,
} from './VehicleBookingDisplay';

/**
 * 
 * @export
 * @interface VehicleBookingDisplays
 */
export interface VehicleBookingDisplays {
    /**
     * 
     * @type {Array<VehicleBookingDisplay>}
     * @memberof VehicleBookingDisplays
     */
    items: Array<VehicleBookingDisplay>;
}

/**
 * Check if a given object implements the VehicleBookingDisplays interface.
 */
export function instanceOfVehicleBookingDisplays(value: object): value is VehicleBookingDisplays {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function VehicleBookingDisplaysFromJSON(json: any): VehicleBookingDisplays {
    return VehicleBookingDisplaysFromJSONTyped(json, false);
}

export function VehicleBookingDisplaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingDisplays {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(VehicleBookingDisplayFromJSON)),
    };
}

export function VehicleBookingDisplaysToJSON(json: any): VehicleBookingDisplays {
    return VehicleBookingDisplaysToJSONTyped(json, false);
}

export function VehicleBookingDisplaysToJSONTyped(value?: VehicleBookingDisplays | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(VehicleBookingDisplayToJSON)),
    };
}

